<i class="fa fa-calendar-alt"></i><b>{{active ? active.name : 'Chọn thời gian'}}</b>

